const files = require.context('.', false, /\.vue$/)
const modules = []
files.keys().forEach(key => {
  let item = files(key).default
  item._key = key.replace(/(\.\/|\.vue)/g, '')
  modules.push(item)
})

export default modules



// WEBPACK FOOTER //
// ./src/components/widgets/index.js